import {isNumber} from 'lodash';
import {INav} from './FoldersHelper';
import {
   INBOUND_FOLDER_NAME,
   KEYS_FOLDER_NAME,
   OUTBOUND_FOLDER_NAME,
   PARTNERS_FOLDER_NAME,
   SFTP_SERVER_FOLDER_NAME,
   SYNCHRONIZATION_FOLDER_NAME,
   TRANSACTIONS_FOLDER_NAME,
} from './utils';

let i = 0;
const indexes = {
   [KEYS_FOLDER_NAME]: i++,
   [PARTNERS_FOLDER_NAME]: i++,
   [TRANSACTIONS_FOLDER_NAME]: i++,
   [SFTP_SERVER_FOLDER_NAME]: i++,
};

let tI = 0;
const transactionIndexs = {
   [INBOUND_FOLDER_NAME]: tI++,
   [OUTBOUND_FOLDER_NAME]: tI++,
   [SYNCHRONIZATION_FOLDER_NAME]: tI++,
};

export function ensureFirstLevelOrder(folders: INav[]) {
   const firstLevel = [];
   let rootFolder;
   const others = [];
   const transactionFolders = [];

   for (let i = 0; i < folders.length; i++) {
      switch (folders[i].level) {
         case 0:
            rootFolder = folders[i];
            break;

         case 1:
            const index = indexes[folders[i].name as keyof typeof indexes];

            if (isNumber(index)) {
               firstLevel[index] = folders[i];
            } else {
               console.error('Should be an index for 1st level folder');
               others.push(folders[i]);
            }
            break;
         case 2:
            const ti = transactionIndexs[folders[i].name as keyof typeof transactionIndexs];
            if (isNumber(ti)) {
               transactionFolders[ti] = folders[i];
            } else {
               others.push(folders[i]);
            }
            break;

         default:
            others.push(folders[i]);
      }
   }

   // console.debug(rootFolder, firstLevel, others);

   return [rootFolder, ...firstLevel, ...transactionFolders, ...others] as INav[];
}
